import { useSelector } from 'react-redux';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { SmallSpinner } from '../../../../../common';
import NoOrdersDefaultState from './NoOrdersDefaultState';
import NoOrdersSearchState from './NoOrdersSearchState';

export default function EmptyStateReceiveOrders({ ordersLoading }) {
  const { ordersToRetrieveFilters: filters } = useSelector(
    (state) => state.orders
  );

  const isSearch = Boolean(filters.filter || filters.id_warecloud);

  if (ordersLoading) {
    return (
      <Card elevation={1} sx={{ borderRadius: 3 }}>
        <CardContent>
          <SmallSpinner />
        </CardContent>
      </Card>
    );
  }
  return (
    <Card elevation={1} sx={{ borderRadius: 3 }}>
      <CardContent>
        {isSearch ? <NoOrdersSearchState /> : <NoOrdersDefaultState />}
      </CardContent>
    </Card>
  );
}
